var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search_result_box"},[_c('div',{staticClass:"container"},[_c('good-list',{attrs:{"good-list":_vm.goodList}}),(!_vm.goodListLoading && !_vm.goodList.length)?_c('el-empty',{attrs:{"description":" "}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }